import { useEffect, useState } from 'react';
import { RiCloseFill } from 'react-icons/ri';
import ReactModal from 'react-modal';

import Sidebar from 'components/sidebar';
import { useAuth } from 'context/AuthContext';
import { VERSION } from 'utils/constants';

export function NavMobile({ ...props }) {
  const { user } = useAuth();

  ReactModal.setAppElement('#modal');

  const [modalIsOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  useEffect(() => {
    const onOpenModal = () => {
      setIsOpen(true);
    };

    document.addEventListener('openNavMobile', onOpenModal);

    return () => {
      document.removeEventListener('openNavMobile', onOpenModal);
    };
  }, []);

  return (
    <div className="relative z-30">
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Menu Mobile"
        overlayClassName="fixed z-50 top-0 left-0 w-full h-full bg-surface-app flex flex-col items-center"
        contentElement={() => (
          <div className="relative flex h-full w-full flex-col overflow-y-auto p-6">
            <div className="mb-8 flex w-full items-center justify-between">
              <p className="font-display text-xl font-bold text-brand-blue">Olá, {user?.name?.split(' ')[0]}!</p>

              <button
                type="button"
                onClick={closeModal}
                aria-label="Fechar menu"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-blue text-xl text-brand-white"
              >
                <RiCloseFill className="block" />
              </button>
            </div>

            <Sidebar onNavigate={closeModal} />

            <div className="mt-8 text-center text-xs text-content-soft">{VERSION}</div>
          </div>
        )}
      />
    </div>
  );
}
